import { apiClient } from './api-client'
import { API_ENDPOINTS } from '@/config/constants'
import { GridState } from '@/stores/grid-configuration.store'

export const gridConfigurationService = {
  getGridConfiguration: async (): Promise<GridState> => {
    return apiClient.get<{ data: GridState }>(API_ENDPOINTS.GRID_CONFIGURATIONS.BASE).then(res => (res as any).data || res)
  },

  saveGridConfiguration: async (state: GridState): Promise<void> => {
    return apiClient.patch(API_ENDPOINTS.GRID_CONFIGURATIONS.BASE, { state })
  },
}


